import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightReservationCard } from './ui/flight_reservation.js';

export { FlightReservationCard } from './ui/flight_reservation.js';

/** Entrada de catálogo do `flight_reservation` (slot chat) — display-only. */
export const flightReservationEntry: GenUiEntry<Extract<ChatUi, { kind: 'flight_reservation' }>> = {
  kind: 'flight_reservation',
  slot: 'chat',
  policy: { productOf: () => 'flight' },
  render: ({ ui, note }) => <FlightReservationCard reservation={ui.reservation} note={note} />,
};
